export default "__VITE_ASSET__DKzK26OO__"